// extracted by mini-css-extract-plugin
export default {"chipRow":"RelationGroupChips_chipRow__vV2Dd"};